// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import EmployesPage from './pages/EmployesPage';
import CongesPage from './pages/CongesPage';
import TempsPage from './pages/TempsPage';
import SdtcPage from './pages/SdtcPage';        // §3.58 Solde de tout compte
import PaiePage from './pages/PaiePage';
import ApprobationsPage from './pages/ApprobationsPage';
import PointagePage from './pages/PointagePage';
import ParametresPage from './pages/ParametresPage';
import UtilisateursPage from './pages/UtilisateursPage';
import RolesPage from './pages/RolesPage';

import './styles.css';

// ── Rôles admin définis dans UtilisateurController::ROLES ────────────
// Correspondent aux rôles réellement stockés en base et vérifiés par l'API.
// 'employe' n'existe pas en base — la garde précédente laissait passer
// tous les non-admins (gestionnaire, lecteur) vers les pages sensibles.
const ADMIN_ROLES = ['direction', 'super_admin', 'admin_rh'];

function RequireAuth({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!ADMIN_ROLES.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
            <Route index element={<Dashboard />} />
            <Route path="employes"     element={<AdminOnly><EmployesPage /></AdminOnly>} />
            <Route path="conges"       element={<CongesPage />} />
            <Route path="temps"        element={<TempsPage />} />
            <Route path="paie"         element={<AdminOnly><PaiePage /></AdminOnly>} />
            <Route path="sdtc"         element={<AdminOnly><SdtcPage /></AdminOnly>} />{/* §3.58 */}
            <Route path="approbations" element={<AdminOnly><ApprobationsPage /></AdminOnly>} />
            <Route path="pointage"     element={<AdminOnly><PointagePage /></AdminOnly>} />
            <Route path="parametres"   element={<AdminOnly><ParametresPage /></AdminOnly>} />
            <Route path="utilisateurs" element={<AdminOnly><UtilisateursPage /></AdminOnly>} />
            <Route path="roles"        element={<AdminOnly><RolesPage /></AdminOnly>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}